import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { FanNewsStory, isUreportStoryUrl } from '../fan-news/fan-news.model';

export interface FanNewsDialogData {
  story: FanNewsStory;
}

// Shows a uReport story inside BigBee (iframe), so the fan never leaves the agent page.
@Component({
  selector: 'app-fan-news-story-dialog',
  templateUrl: './fan-news-story-dialog.component.html',
  styleUrls: ['./fan-news-story-dialog.component.scss'],
})
export class FanNewsStoryDialogComponent {
  story: FanNewsStory | null = null;
  storyUrl: SafeResourceUrl | null = null;

  constructor(
    private dialogRef: MatDialogRef<FanNewsStoryDialogComponent>,
    private sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) data: FanNewsDialogData
  ) {
    // Only uReport story pages are ever loaded into the iframe.
    if (isUreportStoryUrl(data?.story?.storyUrl)) {
      this.story = data.story;
      this.storyUrl = this.sanitizer.bypassSecurityTrustResourceUrl(data.story.storyUrl);
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
